import React from "react"
import {
  Button,
  FormInput,
  QuestionnaireActionBtns,
  Title,
} from "@thedgbrt/logology-ui-components"
import { connect } from "react-redux"
import { navigate } from "gatsby"
import API, { graphqlOperation } from "@aws-amplify/api"
import {
  nextStep,
  saveStepAndGoNext,
  setStartupName,
} from "../../state/actions/questionnaire"
import useStartupNameForm from "./useStartupNameForm"

const StartupName = ({
  basepath,
  initValue,
  setStartupName,
  step,
  saveStepAndGoNext,
  type,
}) => {
  let inputRef = React.createRef()

  const handleSuccess = () => {
    setStartupName(inputValue)
    navigate(`${basepath}${step + 1}`)
    if (type === "private") saveStepAndGoNext(API, graphqlOperation)
  }

  const {
    inputError,
    inputValue,
    handleInputChange,
    handleSubmit,
  } = useStartupNameForm(initValue, handleSuccess)

  return (
    <>
      <Title level={3}>My brand name</Title>

      <FormInput
        placeholder="Type in your brand name"
        type="text"
        name="startupName"
        id="startup-name-input"
        error={inputError}
        onChange={e => handleInputChange(e, inputRef)}
        value={inputValue}
        ref={inputRef}
      />

      <QuestionnaireActionBtns>
        <Button onClick={handleSubmit}>next →</Button>
      </QuestionnaireActionBtns>
    </>
  )
}

export default connect(
  ({ questionnaire }) => ({
    initValue: questionnaire.startupName,
  }),
  { nextStep, saveStepAndGoNext, setStartupName }
)(StartupName)
